const Close = ({ title = 'Close', color = '#000' }) => (
  <svg
    width='14px'
    height='16px'
    viewBox='0 0 14 16'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g
      id='Separate'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='Widget-Improvements'
        transform='translate(-1276.000000, -33.000000)'
        stroke={color}
        strokeWidth='2.5'
      >
        <path
          d='M1277,34 L1288.58301,45.5830078 M1289,34 L1277,45.5830078'
          id='Combined-Shape'
        />
      </g>
    </g>
  </svg>
)

export default Close
